import styled from '@emotion/styled'
import { WppTypography } from '@platform-ui-kit/components-library-react'

import { ApplicationSelectableCardsFilter } from 'pages/applications/list/components/ApplicationSelectableCardsFilter'

export const CategoryFilter = styled(ApplicationSelectableCardsFilter)`
  .category-card {
    width: calc(33% - 16px);
    min-width: 100px;
    height: 103px;
    &::part(card) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`

export const CategoryIcon = styled('img')`
  width: 32px;
  height: 32px;
  object-fit: contain;
`

export const CategoryLabel = styled(WppTypography)`
  color: var(--wpp-grey-color-1000);
  text-align: center;
  max-width: 66px;
  word-break: break-word;
`
